import { createSlice } from "@reduxjs/toolkit";

export const languageSlice = createSlice({
    name: "language",
    initialState: {
        language: "en",
    },
    reducers: {
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
    },
});

const { reducer, actions } = languageSlice;
export const { setLanguage } = actions;
export default reducer;